const DataWrap = Object.freeze({
  text: { value: 'text' },
  email: { value: 'email' },
  longtext: { value: 'longtext' },
  date: { value: 'date' },
  relativeDate: { value: 'relativeDate' },
  url: { value: 'url' },
  chip: { value: 'chip' },
  select: { value: 'select' },
  files: { value: 'files' },
  image: { value: 'image' },
  custom: { value: 'custom' },
})

const DataWrapExampleInput= Object.freeze({
  text: 'Sample Text',
  email: 'test@asd.asd',
  // longtext: 'This is a long text example that exceeds the usual length to demonstrate how long text is handled in the data wrap component.',
  date: '2023-10-01',
  relativeDate: '2023-10-01',
  url: 'https://www.example.com',
  chip: {
    value: 'example-chip',
    items: [
      { text: 'Example Chip', value: 'example-chip', color: 'primary' },
      { text: 'Sample Chip', value: 'sample-chip', color: 'secondary' },
    ]
  },
  select: {
    value: 'option1',
    items: [
      { text: 'Option 1', value: 'option1' },
      { text: 'Option 2', value: 'option2' },
    ]
  },
  // files: [
  //   { name: 'document.pdf', size: 204800, type: 'application/pdf' },
  //   { name: 'image.png', size: 102400, type: 'image/png' }
  // ],
  // image: {src:'https://via.placeholder.com/150'},
})


/**
<template v-for="(value, key) in DataWrapExampleInput" :key="key">
  <div>{{ key }}: {{ value }}</div>
  <VDivider class="my-2"/>
  <DataWarp v-if="typeof value !== 'object'" :type="key" :value="value" />
  <DataWarp v-else :type="key" v-bind="value" />
  <VDivider class="my-2"/>
</template>
 */



// create an array of values
// [ 'text', 'email', 'longtext', 'date', 'relativeDate', 'url', 'chip', 'files', 'image', 'custom' ]
const DataWrapArray = Object.values(DataWrap).map(item => item.value)

const InputWrap = Object.freeze({
  text: { value: 'text' },
  textarea: { value: 'textarea' },
  number: { value: 'number' },
  checkbox: { value: 'checkbox' },
  switch: { value: 'switch' },
  radio: { value: 'radio' },
  file: { value: 'file' },
  date: { value: 'date' },
  time: { value: 'time' },
  select: { value: 'select' },
  autoComplete: { value: 'autoComplete' },
  combobox: { value: 'combobox' },
  slider: { value: 'slider' },
  dateRange: { value: 'dateRange' },
  rangeSlider: { value: 'rangeSlider' },
})

const InputWrapArray = Object.values(InputWrap).map(item => item.value)

export {
  DataWrap,
  InputWrap,
  DataWrapArray,
  InputWrapArray,
  DataWrapExampleInput,
}
